
import { WizardViewModel } from '../wizard-view-model';
import { DentallyWizardService } from '../dentally-wizard.service';
import { OnInit, Component, OnDestroy } from "@angular/core";
import { IHasStepNumber } from "src/core/interfaces/IHasStepNumber";
import { Router } from "@angular/router";
import * as moment from 'moment';
import { IntegrationCustomerStatus } from '../IntegrationCustomerStatus';
@Component({
    selector: 'app-dentally-communications',
    templateUrl: './dentally-start.component.html',
    styleUrls: ['./dentally-start.component.scss']
})
export class DentallyStartComponent implements OnInit, OnDestroy, IHasStepNumber {
   
    wizardState: WizardViewModel;
    showLoading=false;
    showError = false;
    integrationTimeOutError = false;
    intevalTimer: any;

    constructor(private router: Router, private dentallyService: DentallyWizardService) {

    }

    stepNumber: number = 2;
    agreeCheckbox: boolean = false;
    ngOnInit(): void {
        this.dentallyService.getWizardState()
            .subscribe(s => {
                this.wizardState = s;                
            });
    }

    onStartUsingClick() {
        this.showError = false;
        this.showLoading=true;
        this.wizardState.data.step = "Start";
        this.wizardState.complete = true;
        this.dentallyService.updateWizardStep(this.wizardState)
            .subscribe(s => {
                if (s.errors && s.errors.length > 0) {
                    this.showLoading=false;
                    this.showError = true;
                    if (s.errors.some(e => e === "IntegrationTimeOutError")) {
                        this.integrationTimeOutError = true;
                    }
                } else {
                    this.cleanupAndNavigateOut();
                }
            }, err=>{
                this.showLoading=false;
            });
    }

    private cleanupAndNavigateOut() {
        this.dentallyService.removeFromLocal();
        this.dentallyService.activateLaunchButton();
        this.router.navigate(['/content'])
            .then(() => {
                window.location.reload();
            });
    }

    ngOnDestroy(): void {
        if (this.intevalTimer) {
            clearInterval(this.intevalTimer);
          }
    }
}